"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 16 2018
 */

var immutable_1 = require("immutable");

var moment = require("moment");

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var CurrencyRate_1 = require("./CurrencyRate");
/**
 * Represents internal currencies with their rates.
 *
 * @author RV
 * @author JMe
 */


var Currency =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Currency, _DomainObject_1$Domai);

  /**
   *  Constructs currency.
   *
   * @param id
   * @param externalId the external id
   * @param code the code of currency, e.g. CZK for czech crowns.
   * @param name
   * @param shortName shorter name
   * @param rates the currency rates
   */
  function Currency(id, externalId, code, // fixme some currencies within idb has null values, verify this with Logio
  name, shortName) {
    var _this;

    var rates = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : immutable_1.List();

    _classCallCheck(this, Currency);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Currency).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.code = code;
    _this.name = name;
    _this.shortName = shortName;
    _this.rates = rates;
    return _this;
  }
  /**
   * @returns active currency rate if any
   */


  _createClass(Currency, [{
    key: "getActiveRate",
    value: function getActiveRate(date) {
      // there should be only one active currency rate at the time.
      date = date || moment();
      var rates = this.rates.filter(function (item) {
        return date.isSameOrAfter(item.validFrom) && date.isSameOrBefore(item.validTo);
      });

      if (rates.size !== 1) {
        throw new Error("Only one currency rate can be valid at given time '".concat(date, "' and it should exist. ") + "Found ".concat(rates.toJS(), " rates for currency ").concat(this.id, " (").concat(this.name, ")"));
      }

      return rates.get(0);
    }
    /**
     * Adds given rate to rates. If there is some rate with same {@link CurrencyRate.validFrom}, it is updated.
     * @param currencyRate the currency rate
     * @returns updated Currency
     */

  }, {
    key: "addRate",
    value: function addRate(currencyRate) {
      return this.copy('rates', this.removeRate(currencyRate).rates.push(currencyRate));
    }
    /**
     * Removes given rate from rates (based on validFrom).
     * @param currencyRate the currency rate
     * @returns updated Currency
     */

  }, {
    key: "removeRate",
    value: function removeRate(currencyRate) {
      if (this.rates.size === 0) {
        return this;
      }

      var index = this.rates.findIndex(function (r) {
        return r.validFrom.isSame(currencyRate.validFrom);
      });
      return index === -1 ? this : this.copy('rates', this.rates.remove(index));
    }
  }]);

  return Currency;
}(DomainObject_1.DomainObject);

exports.Currency = Currency;
/**
 * Lookup for all currencies
 */

Currency.CURRENCIES_LOOKUP = CodebookLookupSequence_1.CodebookLookupSequence.Currency; // tslint:disable-next-line:member-ordering

Currency.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Currency.name);
  return {
    id: builder.id('id'),
    externalId: builder.id('externalId'),
    code: builder.opt(builder.str('code')),
    name: builder.str('name'),
    shortName: builder.str('shortName'),
    rates: builder.listOf(builder.obj('rates', CurrencyRate_1.CurrencyRate.schema, function (mat) {
      return new CurrencyRate_1.CurrencyRate(mat.validFrom, mat.validTo, mat.rate);
    }))
  };
}();